module.exports = __webpack_public_path__ + "static/media/dots.4fd77b93.svg";